import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { ContactDetails, PageIntro, useTranslatedList } from './shared';

export function Support() {
  const { t } = useTranslation();
  const faq = useTranslatedList<{ q: string; a: string }>('public.support.faq');
  return (
    <div className="prose">
      <PageIntro title={t('public.support.title')} lead={t('public.support.lead')} />
      <section className="prose-section" aria-labelledby="support-contact">
        <h2 id="support-contact">{t('public.support.contactHeading')}</h2>
        <ContactDetails />
      </section>
      <section className="prose-section" aria-labelledby="support-faq">
        <h2 id="support-faq">{t('public.support.faqHeading')}</h2>
        <dl className="faq-list">
          {faq.map((item, i) => (
            <div key={i} className="faq-item">
              <dt>{item.q}</dt>
              <dd>{item.a}</dd>
            </div>
          ))}
        </dl>
      </section>
      <p className="info-card-links">
        <Link to="/privacy" className="text-link">{t('public.footer.privacy')}</Link>
        <Link to="/editorial-standards" className="text-link">{t('public.footer.editorial')}</Link>
      </p>
    </div>
  );
}
